// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';

import { THButton } from '@Molecules/Inputs/THButton/THButton';
import { ICONS } from '@Constants/iconsApp';
import { useLocalMessage } from '@Helpers/locale';
import { ExportEntitiesType, QueryParams } from 'thehive-sdk';
import { ExportDrawer } from '@Organisms/Export';

export interface ExportButtonProps {
    label?: string;
    onClick(): void;
    objectType: ExportEntitiesType;
    objectId?: string;
    selectedItems: string[];
    visible: boolean;
    afterVisible: (visible: boolean) => void;
    queryParams?: QueryParams;
    listNumber?: number;
}

export const ExportButton = ({
    label,
    onClick,
    queryParams,
    selectedItems,
    afterVisible,
    visible,
    objectType,
    listNumber,
}: ExportButtonProps): ReactElement => {
    const i = useLocalMessage();

    return (
        <>
            <THButton type="default" onClick={onClick}>
                <ICONS.ExportOutlined className="hide-on-visible" />
                <span className="button-text">
                    {label || i(selectedItems.length ? 'export.action.label-selected' : 'export.action.label-list')}
                </span>
            </THButton>
            <ExportDrawer
                objectType={objectType}
                selectedItems={selectedItems}
                queryParams={queryParams}
                visible={visible}
                afterVisible={afterVisible}
                listNumber={listNumber}
            />
        </>
    );
};
